import customAxios from "../../customHook/customAxios";
import { getAuthHeader } from "../../utils";

export const v3_add_state = async (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/master-data/state`;
    return customAxios.post(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
}

export const v3_states = async (page, limit) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/master-data/state/${page}/${limit}`;
    return customAxios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}

export const v3_states_visibility = async (id, visibility) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/master-data/state/${id}`;
    return customAxios.patch(url, { visibility: visibility }, getAuthHeader()).then((res) => {
        return res.data;
    })
}


export const v3_edit_states = async (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/master-data/state`;
    return customAxios.put(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
}

export const v3_all_states = async (country) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/master-data/states/${country}`;
    return customAxios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}

export const v3_all_countries = async () => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/master-data/countries`;
    return customAxios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}


export const v3_add_district = async (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/master-data/district`;
    return customAxios.post(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
}



export const v3_districts = async (page, limit) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/master-data/district/${page}/${limit}`;
    return customAxios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}

export const v3_districts_visibility = async (id, visibility) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/master-data/district/${id}`;
    return customAxios.patch(url, { visibility: visibility }, getAuthHeader()).then((res) => {
        return res.data;
    })
}

export const v3_edit_districts = async (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/master-data/district`;
    return customAxios.put(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
}



export const v3_add_leaveType = async (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/master-data/leaveType`;
    return customAxios.post(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
}


export const v3_leaveTypes = async (page, limit) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/master-data/leaveType/${page}/${limit}`;
    return customAxios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}


export const v3_leaveType_visibility = async (id, visibility) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/master-data/leaveType/${id}`;
    return customAxios.patch(url, { visibility: visibility }, getAuthHeader()).then((res) => {
        return res.data;
    })
}



export const v3_edit_leaveType = async (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/master-data/leaveType`;
    return customAxios.put(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
}





export const v3_add_expenseType = async (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/master-data/expenseType`;
    return customAxios.post(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
}


export const v3_expenseTypes = async (page, limit) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/master-data/expenseType/${page}/${limit}`;
    return customAxios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}


export const v3_expenseType_visibility = async (id, visibility) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/master-data/expenseType/${id}`;
    return customAxios.patch(url, { visibility: visibility }, getAuthHeader()).then((res) => {
        return res.data;
    })
}



export const v3_edit_expenseType = async (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/master-data/expenseType`;
    return customAxios.put(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
}



export const v3_add_yard = async (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/master-data/yard`;
    return customAxios.post(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
}


export const v3_yards = async (page, limit, payload) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/master-data/yard/${page}/${limit}${payload ? `?payload=${payload}` : ''}`;
    return customAxios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}


export const v3_yard_visibility = async (id, visibility) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/master-data/yard/${id}`;
    return customAxios.patch(url, { visibility: visibility }, getAuthHeader()).then((res) => {
        return res.data;
    })
}



export const v3_edit_yard = async (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/master-data/yard`;
    return customAxios.put(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
}


export const v3_add_ship_type = async (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/master-data/shipType`;
    return customAxios.post(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
}



export const v3_ship_types = async (page, limit) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/master-data/shipType/${page}/${limit}`;
    return customAxios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}


export const v3_ship_type_visibility = async (id, visibility) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/master-data/shipType/${id}`;
    return customAxios.patch(url, { visibility: visibility }, getAuthHeader()).then((res) => {
        return res.data;
    })
}



export const v3_edit_ship_type = async (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/master-data/shipType`;
    return customAxios.put(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
}




export const v3_add_sub_contractor = async (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/master-data/subContractor`;
    return customAxios.post(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
}



export const v3_sub_contractors = async (page, limit) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/master-data/subContractor/${page}/${limit}`;
    return customAxios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}


export const v3_sub_contractors_visibility = async (id, visibility) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/master-data/subContractor/${id}`;
    return customAxios.patch(url, { visibility: visibility }, getAuthHeader()).then((res) => {
        return res.data;
    })
}



export const v3_edit_sub_contractor = async (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/master-data/subContractor`;
    return customAxios.put(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
}



export const v3_add_project_location = async (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/master-data/projectLocation`;
    return customAxios.post(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
}



export const v3_project_locations = async (page, limit) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/master-data/projectLocation/${page}/${limit}`;
    return customAxios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}


export const v3_project_location_visibility = async (id, visibility) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/master-data/projectLocation/${id}`;
    return customAxios.patch(url, { visibility: visibility }, getAuthHeader()).then((res) => {
        return res.data;
    })
}



export const v3_edit_project_location = async (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/master-data/projectLocation`;
    return customAxios.put(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
}



export const v3_add_site_location = async (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/master-data/siteLocation`;
    return customAxios.post(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
}



export const v3_site_locations = async (page, limit) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/master-data/siteLocation/${page}/${limit}`;
    return customAxios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}


export const v3_site_location_visibility = async (id, visibility) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/master-data/siteLocation/${id}`;
    return customAxios.patch(url, { visibility: visibility }, getAuthHeader()).then((res) => {
        return res.data;
    })
}

export const v3_edit_site_location = async (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/master-data/siteLocation`;
    return customAxios.put(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
}

export const v3_add_schedule_category = async (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/master-data/schedule-category`;
    return customAxios.post(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
}

export const v3_add_category = async (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/master-data/category`;
    return customAxios.post(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
}

export const v3_add_company = async (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/master-data/company`;
    return customAxios.post(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
}

export const v3_companies = async (page, limit) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/master-data/company/${page}/${limit}`;
    return customAxios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}

export const v3_company_visibility = async (id, visibility) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/master-data/company/${id}`;
    return customAxios.patch(url, { visibility: visibility }, getAuthHeader()).then((res) => {
        return res.data;
    })
}

export const v3_edit_company = async (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/master-data/company`;
    return customAxios.put(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
}

export const v3_schedule_categories = async (page, limit) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/master-data/schedule-category/${page}/${limit}`;
    return customAxios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}

export const v3_categories = async (page, limit) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/master-data/category/${page}/${limit}`;
    return customAxios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}

export const v3_schedule_category_visibility = async (id, visibility) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/master-data/schedule-category/${id}`;
    return customAxios.patch(url, { visibility: visibility }, getAuthHeader()).then((res) => {
        return res.data;
    })
}

export const v3_category_visibility = async (id, visibility) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/master-data/category/${id}`;
    return customAxios.patch(url, { visibility: visibility }, getAuthHeader()).then((res) => {
        return res.data;
    })
}

export const v3_edit_schedule_category = async (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/master-data/schedule-category`;
    return customAxios.put(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
}

export const v3_edit_category = async (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/master-data/category`;
    return customAxios.put(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
}

export const v3_add_event_type = async (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/master-data/eventType`;
    return customAxios.post(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
}

export const v3_events = async (page, limit) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/master-data/eventType/${page}/${limit}`;
    return customAxios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}

export const v3_event_visibility = async (id, visibility) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/master-data/eventType/${id}`;
    return customAxios.patch(url, { visibility: visibility }, getAuthHeader()).then((res) => {
        return res.data;
    })
}

export const v3_edit_event = async (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/master-data/eventType`;
    return customAxios.put(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
}

export const v3_add_document_type = async (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/master-data/documentType`;
    return customAxios.post(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
}

export const v3_document_types = async (page, limit) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/master-data/documentType/${page}/${limit}`;
    return customAxios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}

export const v3_document_type_visibility = async (id, visibility) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/master-data/documentType/${id}`;
    return customAxios.patch(url, { visibility: visibility }, getAuthHeader()).then((res) => {
        return res.data;
    })
}

export const v3_edit_document_type = async (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/master-data/documentType`;
    return customAxios.put(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
}


export const v3_add_plan_type = async (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/master-data/planType`;
    return customAxios.post(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
}

export const v3_plan_types = async (page, limit) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/master-data/planType/${page}/${limit}`;
    return customAxios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}

export const v3_plan_type_visibility = async (id, visibility) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/master-data/planType/${id}`;
    return customAxios.patch(url, { visibility: visibility }, getAuthHeader()).then((res) => {
        return res.data;
    })
}

export const v3_edit_plan_type = async (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/master-data/planType`;
    return customAxios.put(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
}

export const v3_add_remark_option = async (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/master-data/remark-option`;
    return customAxios.post(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
}

export const v3_remark_options = async (page, limit) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/master-data/remark-option/${page}/${limit}`;
    return customAxios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}

export const v3_all_remark_options = async () => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/master-data/remark-option/all`;
    return customAxios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}

export const v3_remark_option_visibility = async (id, visibility) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/master-data/remark-option/${id}`;
    return customAxios.patch(url, { visibility: visibility }, getAuthHeader()).then((res) => {
        return res.data;
    })
}

export const v3_edit_remark_option = async (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/master-data/remark-option`;
    return customAxios.put(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
}


export const v3_add_builder = async (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/master-data/builder`;
    return customAxios.post(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
}



export const v3_builders = async (page, limit) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/master-data/builder/${page}/${limit}`;
    return customAxios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}


export const v3_builder_visibility = async (id, visibility) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/master-data/builder/${id}`;
    return customAxios.patch(url, { visibility: visibility }, getAuthHeader()).then((res) => {
        return res.data;
    })
}



export const v3_edit_builder = async (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/master-data/builder`;
    return customAxios.put(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
}



export const v3_add_shipyard = async (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/master-data/shipYard`;
    return customAxios.post(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
}



export const v3_shipyards = async (page, limit) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/master-data/shipYard/${page}/${limit}`;
    return customAxios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}


export const v3_shipyard_visibility = async (id, visibility) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/master-data/shipYard/${id}`;
    return customAxios.patch(url, { visibility: visibility }, getAuthHeader()).then((res) => {
        return res.data;
    })
}



export const v3_edit_shipyard = async (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/master-data/shipYard`;
    return customAxios.put(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
}



export const v3_add_channel = async (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/master-data/channel`;
    return customAxios.post(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
}

export const v3_channels = async (page, limit) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/master-data/channel/${page}/${limit}`;
    return customAxios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}

export const v3_channel_visibility = async (id, visibility) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/master-data/channel/${id}`;
    return customAxios.patch(url, { visibility: visibility }, getAuthHeader()).then((res) => {
        return res.data;
    })
}

export const v3_edit_channel = async (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/master-data/channel`;
    return customAxios.put(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
}
